import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=4b854181&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b854181",
  null
  
)

export default component.exports